module.exports = __webpack_public_path__ + "img/SketchPng2c7c1ad8cab33815fd0bdc02ae1a77af735be8e591523eba26480bcba40a5ba1.ff22b17d.png";